import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  distance: 100,
  genderPreference: 'F',
  refreshProfiles: false,
  language: 'fr' 
};

const preferencesSlice = createSlice({
  name: 'preferences',
  initialState,
  reducers: {
    setDistance: (state, action) => {
      state.distance = action.payload; 
    },
    setGenderPreference: (state, action) => {
      state.genderPreference = action.payload;
    },
    updatePreferences: (state, action) => {
      return { ...state, ...action.payload };
    },
    setRefreshProfiles: (state, action) => {
      state.refreshProfiles = action.payload;
    },
    setLanguage: (state, action) => {
      state.language = action.payload;
    }
  },
});

export const { setDistance, setGenderPreference, updatePreferences, setRefreshProfiles, setLanguage } = preferencesSlice.actions;
export default preferencesSlice.reducer;
